<template>
    <div class="w-100 h-100">
        <!-- MODALS -->
        <!-- https://bootstrap-vue.org/docs/components/modal -->
        <!-- This modal shows if there is a problem with the API call. -->
        <b-modal
            id="api-err-modal"
            v-model="showApiErrModal"
            centered
            scrollable
            hide-footer
            hide-header-close
            no-close-on-backdrop
            no-close-on-esc
            title="Dataset Fetch Error"
            :header-bg-variant="'warning'"
            :header-text-variant="'light'">
            <span v-html="err_msg"></span>
            <b-button class="mt-3 button-link" :to="{name: 'product-bag-summary'}" block>Return to Product Bag Summary</b-button>
        </b-modal>
        <b-modal
            id="submit-modal"
            v-model="showSubmitModal"
            centered
            scrollable
            title="Submit Product Bag Changes?"
            :header-bg-variant="'warning'"
            :header-text-variant="'light'"
            @ok="submitProductBag"
        >
            <div class="text-center">
                <div>Are you sure you want to submit these changes?</div>
            </div>
        </b-modal>
        <b-modal
            v-model="showModal"
            hide-header
            hide-header-close
            centered
            no-close-on-backdrop
            @ok="OKClick"
        >
            <div v-if="ModalHTMLMessage != ''" v-html="ModalHTMLMessage"></div>
            <div v-else class="text-center">
                <div>{{ModalMessage}}</div>
            </div>
            <!-- <template #modal-footer>
                <b-button variant="secondary" @click="cancelForm">Cancel</b-button>
                <b-button class="ml-2" variant="primary" @click="submitProductBag">Submit</b-button>
            </template> -->
        </b-modal>
        <!-- This modal shows when the curator clicks the "Archive" button. -->
        <b-modal
            id="archive-product-bag-modal"
            v-model="showArchiveProductBagModal"
            centered
            scrollable
            no-close-on-backdrop
            title="Confirm Product Bag Archival"
            ok-title="Yes, Archive Product Bag"
            @show="resetModal"
            @hidden="resetModal"
            @ok="handleOk"
            :header-bg-variant="'danger'"
            :header-text-variant="'light'"
        >
            <!-- <p class="my-4">{{modalText}}</p> -->
            <span v-html="'Are you sure you want to archive this product bag?'"></span>
            <form ref="form" @submit.stop.prevent="handleArchiveSubmit">
            <b-form-group
                invalid-feedback="Confirmation is required"
                :state="deleteConfirmState"
            >
            <br>
            <b-form-checkbox
                id="delete-confirm-input"
                name="delete-confirm-chkbx"
                v-model="deleteConfirmed"
            >I'm sure.</b-form-checkbox>
            </b-form-group>
        </form>
        </b-modal>
        <!-- This modal shows while the dataset is being deleted. -->
        <b-modal
            id="warning-modal"
            v-model="showDeleteWorkingModal"
            centered
            scrollable
            hide-footer
            hide-header-close
            no-close-on-backdrop
            no-close-on-esc
            title="Archiving Product Bag"
            :header-bg-variant="'warning'"
            :header-text-variant="'light'"
        >
            <span v-html="'Please wait while the product bag is archived.'"></span>
        </b-modal>
        
        <b-container fluid>
            <b-row>
                <b-col>
                    <h2 class="tw-mb-0 text-aegis-dk">Edit Product Bag</h2>
                    <p class="tw-italic tw-text-gray-700">
                        Edit product bag details. Note that all changes are logged.
                    </p>
                </b-col>
                <b-col>
                    <div style="float: right;">
                        <b-button 
                            class="ml-1 button-link" 
                            :to="{name: 'product-bag-summary'}" 
                            variant="primary" 
                            size="sm" 
                            block
                        >
                            Return to Product Bag Summary
                        </b-button>
                        <b-button 
                            class="ml-1 button-link" 
                            variant="danger" 
                            size="sm" 
                            block
                            @click="showArchiveProductBagModal = true"
                        >
                            Archive This Product Bag
                        </b-button>
                    </div>
                </b-col>
            </b-row>
        </b-container>
        <br />

        <b-container fluid>
            <b-card bg-variant="light" class="tw-mx-3">
                <b-row>
                    <b-col cols="10">
                        <h4>Product Bag ID: {{ id }}</h4>
                        <h6>Prepared on: {{ prepared_date }}</h6>
                        <h6>Received on: {{ returned_date }}</h6>
                        <h6>Placement Type: {{ placement_type }}</h6>
                        <h6>This structure requires {{products_required}} products.</h6>
                        <h6 style="color: red;">
                            When making changes to product bag data,
                            please also update the Product Enrolled Structure case on 
                            CommCare to ensure that the data remains consistent.
                        </h6>
                        <br />
                    </b-col>
                </b-row>
                <b-row class="mt-2">
                    <b-col>
                        <b-form-group
                            label-cols-sm="4"
                            :id=household_id
                            :label="'Household ID'"
                        >
                            <b-form-input
                                v-model="household_id"
                                :placeholder=household_id
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row class="mt-2">
                    <b-col>
                        <b-form-group
                            label-cols-sm="4"
                            :id=new_product_bag_barcode
                            :label="'New Product Bag Barcode'"
                        >
                            <b-form-input
                                v-model="new_product_bag_barcode"
                                :placeholder=new_product_bag_barcode
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row class="mt-2">
                    <b-col>
                        <b-form-group
                            label-cols-sm="4"
                            :id=used_product_bag_barcode
                            :label="'Used Product Bag Barcode'"
                        >
                            <b-form-input
                                v-model="used_product_bag_barcode"
                                :placeholder=used_product_bag_barcode
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12">
                        <center>
                            <b-button
                                class="m-2 col-5"
                                variant="success"
                                @click="submitForm()"
                            >
                                Submit
                            </b-button>
                        </center>
                    </b-col>
                </b-row>
            </b-card>
        </b-container>
    </div>
  </template>
  
<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";
import * as _ from "lodash";
import { mapGetters } from 'vuex';
import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";
  
export default {
mixins: [
    DashboardBaseTemplate,
],
components: {},
props: {
    id: {
      type: [Number, String],
      require: true,
    },
  },
watch: {},
data: function() {
    return {
        showApiErrModal: false,
        showModal: false,
        showSubmitModal: false,
        showArchiveProductBagModal: false,
        showDeleteWorkingModal: false,
        deleteConfirmState: false,
        deleteConfirmed: false,
        ModalMessage: '',
        err_msg: '',
        ModalHTMLMessage: '',
        new_product_bag_barcode: '',
        used_product_bag_barcode: '',
        household_id: '',
        products_required: 0,
        missing_product_count: 0,
        prepared_date: '',
        returned_date: '',
        placement_type: '',
    };
},
computed: {
    ...mapGetters("user", ["inMyGroups"]),
},
created: function() {
    if(!this.inMyGroups(['Product Bag Manager'])) {
        this.err_msg = "You do not have permission to view this page.";
        this.showApiErrModal = true;
    }
},
mounted() {
    this.getProductBag();
},
methods: {
    getProductBag: function () {
        const that = this;
        const fd = new FormData();
        
        fd.append("id", that.id);
        HTTP.post('srilanka/product_bag/get_product_bag_by_id/', fd).then((response) => {
            if(response.data.message != null) {
                this.ModalMessage = response.data.message;
                this.showModal = true;
            }
            if (response.data.message == null || that.bag_already_received != false) {
                that.new_product_bag_barcode = response.data.product_bag.new_product_bag_barcode;
                that.used_product_bag_barcode = response.data.product_bag.used_product_bag_barcode;
                that.household_id = response.data.product_bag.household_id;
                that.products_required = response.data.product_bag.products_required;
                that.prepared_date = response.data.product_bag.prepared_date;
                that.returned_date = response.data.product_bag.returned_date;
                that.placement_type = response.data.product_bag.placement_type;
            }
        }).catch((error) => {
            HandleErrors.HandleErrors(error);
            this.ModalMessage = 'There was a problem. Please check barcode and try again.';
            this.showModal = true;
        });
    },
    submitForm () {
        this.showSubmitModal = true;
    },
    submitProductBag: function() {
        const that = this;
        that.ModalHTMLMessage = '';
        const fd = new FormData();
        fd.append("id", that.id);
        fd.append("new_product_bag_barcode", that.new_product_bag_barcode);
        fd.append("used_product_bag_barcode", that.used_product_bag_barcode);
        fd.append("household_id", that.household_id);
        this.showSubmitModal = false;
        HTTP.put('srilanka/product_bag/edit/', fd).then((response) => {
            if(response.data.message != null) {
                that.household_id = response.data.product_bag.household_id;
                that.new_product_bag_barcode = response.data.product_bag.new_product_bag_barcode;
                that.used_product_bag_barcode = response.data.product_bag.used_product_bag_barcode;
                that.ModalHTMLMessage = '';
                that.ModalMessage = response.data.message;
                that.showModal = true;
            } else {
                that.ModalHTMLMessage = '';
                that.ModalMessage = 'Submitted successfully';
                that.showModal = true;
            }
        }).catch((error) => {
            HandleErrors.HandleErrors(error);
            that.ModalMessage = 'There was a problem. Please check input values and try again.';
            that.showModal = true;
        });
    },
    OKClick: function() {
        this.showModal = false;
    },
    cancelForm() {
        this.ModalHTMLMessage = '';
        this.showModal = false;
    },
    resetModal() {
      this.deleteConfirmed = ''
      this.deleteConfirmState = null
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.handleArchiveSubmit()
    },
    handleArchiveSubmit() {
        // Exit when the form isn't valid
        if (!this.deleteConfirmed) {
            this.deleteConfirmState = false;
            return;
        }
        // Hide the modal manually
        this.showArchiveProductBagModal = false;
        this.archiveProductBag();
    },
    archiveProductBag() {
        this.showDeleteWorkingModal = true;
        const fd = new FormData();
        fd.append("id", this.id);
        return HTTP.post(`srilanka/product_bag/archive/`, fd).then((response) => {
            this.showDeleteWorkingModal = false;
            this.$router.push({name: 'product-bag-summary'})
            return response;
        })
        .catch(error => {
            this.showDeleteWorkingModal = false;
            this.err_msg = HandleErrors.HandleErrors(error);
            this.apiErrModalShow = true;
            return [];
        });
    },
}
};
</script>

<style scoped></style>